export const CATERING_PATH = 'https://www.ezcater.com/brand/pvt/firehouse-subs';
export const FOUNDATION_PATH =
  'https://firehousesubsfoundation.org/about-us/?utm_source=firehousesubs&utm_medium=public_site&utm_campaign=top_nav';
export const CAREERS_PATH = 'https://careers.firehousesubs.com';
export const DONATE_PATH = 'https://firehousesubsfoundation.org/donate/';
